import React from "react";
import * as numeral from "numeral";
import Skeleton, {SkeletonTheme} from "react-loading-skeleton";

export default function Decimal(props) {
    if(props.value || props.skeleton === undefined)
    {
        const formattedValue = numeral(props.value).format(props.format|| "0,0.00");
        return <React.Fragment>{props.prefix}{formattedValue}{props.suffix}</React.Fragment>
    }
    else
    {
        return (
        <SkeletonTheme color="#0071b9" highlightColor="#8ebcd2" >
            <Skeleton />
        </SkeletonTheme>
        )
    }
}